import { Location } from "modules/WBS/models/Location";

export class TaskRows {
  type: string;
  index: number;
  quantity: number;
  total: number;
  disabled: string;
  convertedTotalCost: number;
  contentReference: Location;

  constructor(
    type: string,
    index: number,
    quantity: number,
    total: number,
    disabled: string,
    convertedTotalCost?: number,
    contentReference?: Location
  ) {
    this.type = type;
    this.index = index;
    this.quantity = quantity;
    this.total = total;
    this.disabled = disabled ? disabled : "";
    this.convertedTotalCost = convertedTotalCost ? convertedTotalCost : total;
    if (contentReference !== undefined)
      this.contentReference = contentReference;
  }
  public static getDefault(): TaskRows {
    return new TaskRows("", 0, 0, 0, "");
  }
}



// WEBPACK FOOTER //
// ./src/modules/WBS/models/TaskRows.tsx